import React from "react";
import { works_in_franchise } from "../../../Functionalities/Config";
import defaultProfileImage from "../../../Assets/images/profile_icon.jpg";
import { radiusLabel } from "../radiusLabel";

function RestaurantStatsCard({
  data,
  is_shop_admin,
  is_shop_manager,
  children,
}) {
  return (
    <div className="col-xl-6">
      <div className="card">
        <div className="card-body">
          <div className="profile-statistics mb-5">
            <div className="row text-left">
              <div className="col">
                <span>Restaurant</span>
                <h4 className="m-b-0">{data.branch_name}</h4>
              </div>
              <div className="col">
                <span>Fssai Code</span>
                <h4 className="m-b-0">{data.fssai}</h4>
              </div>
            </div>

            <br />

            <div className="row text-left">
              <div className="col">
                <span>Mobile</span>
                <h4 className="m-b-0">{data.mobile}</h4>
              </div>
              <div className="col">
                <span>Email</span>
                <h4 className="m-b-0">
                  {data.email ? data.email : "No email"}
                </h4>
              </div>
            </div>

            <br />

            <div className="row text-left">
              <div className="col">
                <span>Expense meter</span>
                <h4 className="m-b-0">
                  {data.expence_meter}
                </h4>
              </div>
              <div className="col">
                <span>Average cooking time (in minutes)</span>
                <h4 className="m-b-0">{data.time_to_cook}</h4>
              </div>
            </div>

            <br />

            <div className="row text-left">
              <div className="col">
                <span>Restaurant Radius</span>
                <h4 className="m-b-0">
                  {data.radius}
                </h4>
              </div>
              <div className="col">
                <span>Delivery radius</span>
                <h4 className="m-b-0">{radiusLabel(data.available_radius)}</h4>
              </div>
            </div>

            <hr />
            <div className="row text-left">
              <div className="col">
                <span>Address</span>
                <h4 className="m-b-0">{data.address}</h4>
              </div>
            </div>
          </div>

          {children}

          <div className="profile-news">
            <div className="row">
              <div className="col text-left">
                <h5 className="text-primary d-inline ">
                  Our Managers
                </h5>
              </div>
              {is_shop_admin && (
                <div className="col text-right">
                  <button
                    type="submit"
                    className="btn btn-primary "
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.replace("/addmanager/");
                    }}
                  >
                    Add manager
                  </button>
                </div>
              )}
            </div>
            {data.manager && data.manager.length > 0 ? (
              data.manager.map((man) => {
                return (
                  <div key={man.id} className="media pt-3 pb-3">
                    <img
                      className="mr-3 img-fluid btn-rounded"
                      width={55}
                      height={55}
                      src={defaultProfileImage}
                      alt="Foodoor"
                    />
                    <div className="media-body">
                      <h5 className="m-b-5">
                        <a
                          href={
                            is_shop_admin
                              ? `/manager/${man.id}`
                              : is_shop_manager
                              ? ""
                              : works_in_franchise &&
                                `/resetPassword/${man.id}`
                          }
                          className="text-black"
                        >
                          {man.first_name}
                        </a>
                      </h5>
                      <p className="mb-0">{man.email}</p>
                      <p className="mb-0">
                        {man.details && man.details.mobile}
                      </p>
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-muted mt-2">No managers assigned.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RestaurantStatsCard;
